import React, { useRef, useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import Block from '../../../../components/Block';
import Text from '../../../../components/Text';
import Icon from '../../../../components/Icon';
import { UploadFile } from './UploadFile';
import trashIcon from '../../../../../assets/icons/icon-trash-purple.svg';
import UploaderIcon from '../../../../../assets/icons/icon-uploader-purple.svg';
import PlaceHolderImage from '../../../../../assets/backgrounds/placeholder-image-uploader.svg';
import TextHelpers from '../../../../../core/helpers/TextHelper';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import Interactive from '../Buttons/Interactive';

const DragAndDropArea = styled.div`
  position: relative;
  width: 100%;
  .trash {
    position: absolute;
    right: 14.91px;
    top: 18px;
  }
  @media (max-width: 768px) {
  }
`;
const DragAndDrop = (props: any) => {
  const {
    // children,
    multiple,
    maxFileSize,
    // maxAmountFiles,
    allowedFormats,
    mimeTypeFormats,
    // onUpload,
    onFormatNotAllowed,
    onMaxSizeAllowedOver,
    // onFilesReady,
    onAfterClean,
    onFilesValidated,
    onRequestRemoveFiles,
    withDrapAndDrop,
    cleanAll
  } = props;
  const [filesToSend, setFilesToSend]: any = useState<any>([]);
  const [setFilesLoaded]: any = useState<any>([]);
  const [setFilesWithInvalidFormat]: any = useState(0);
  const [setFilesWithInvalidSize]: any = useState(0);
  const [filesValidationDone, setFilesValidationDone] = useState(false);
  const [dragAndDropAreaPaused, setDragAndDropAreaPaused]: any =
    useState(false);
  const inputOpenFileRef: any = useRef<any>();
  const ButtonRef: any = useRef<any>();
  const bytesToMegaBytes = (bytes: any, digits: any, roundTo: any) =>
    roundTo ? (bytes / (1024 * 1024)).toFixed(digits) : bytes / (1024 * 1024);

  const validateFileSize = (fs: any) => {
    const s: any = bytesToMegaBytes(fs?.size, 2, true);
    return s <= maxFileSize;
  };

  const validateFileFormat = (ff: any) => {
    let b = false;
    if (ff.type === mimeTypeFormats) {
      b = true;
    }

    if (
      (mimeTypeFormats === 'image/jpeg' && ff.type === 'image/jpeg') ||
      (mimeTypeFormats === 'image/jpg' && ff.type === 'image/jpg')
    ) {
      b = true;
    }

    return b;
  };

  const getFileFormat = (ff: any) => {
    let f = '';
    switch (ff) {
      case 'image/jpg':
      case 'image/jpeg':
        f = 'JPG';
        break;
      case 'image/gif':
        f = 'GIF';
        break;
      case 'image/png':
        f = 'PNG';
        break;
      case 'application/pdf':
        f = 'PDF';
        break;
      default:
        break;
    }
    return f;
  };

  const validateFile = (fil: any) =>
    validateFileSize(fil) && validateFileFormat(fil);
  const handleFileSelected = () => {
    if (inputOpenFileRef !== null) {
      setFilesToSend([...inputOpenFileRef.current.files]);
      setDragAndDropAreaPaused(false);
    }
  };
  const handleDragEnter = (event: any) => {
    event.preventDefault();
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const handleClick = () => {
    onAfterClean();
    if (inputOpenFileRef !== null) {
      inputOpenFileRef.current.click();
      setDragAndDropAreaPaused(true);
    }
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    onAfterClean();

    if (inputOpenFileRef !== null) {
      inputOpenFileRef.current.files = event.dataTransfer.files;

      setFilesToSend([...inputOpenFileRef.current.files]);

      setDragAndDropAreaPaused(true);
    }
  };

  const handleRemoveFiles = () => {
    setFilesToSend([]);
    setDragAndDropAreaPaused(false);
    setFilesWithInvalidSize(0);
    setFilesWithInvalidFormat(0);
    setFilesLoaded([]);
    setFilesValidationDone(false);
    onFilesValidated(false);
  };

  const getExt = (filename: any) => {
    const ext = filename.split('.').pop();
    if (ext === filename) return '';
    return ext;
  };

  useEffect(() => {
    if (filesToSend.length && !filesValidationDone) {
      setFilesValidationDone(true);
      let countMaxTime = 0;

      const tFails = filesToSend.map((file: any) => {
        const r = validateFile(file);
        let countFails = 0;
        const s: any = bytesToMegaBytes(file?.size, 2, true);
        if (s >= countMaxTime) {
          countMaxTime = s;
        }

        if (!r) {
          countFails += 1;
        }

        return countFails;
      });

      const tFailsFormat = filesToSend.map((file: any) => {
        const rf = validateFileFormat(file);
        let countFailsFormat = 0;

        if (!rf) {
          countFailsFormat += 1;
        }

        return countFailsFormat;
      });

      const tFailsSize = filesToSend.map((file: any) => {
        const rs = validateFileSize(file);
        let countFailsSize = 0;

        if (!rs) {
          countFailsSize += 1;
        }

        return countFailsSize;
      });

      if (tFails.filter(Boolean).length > 0) {
        let limit = countMaxTime * 1000;
        if (countMaxTime > 3) {
          limit = 1500;
        }
        if (filesToSend.length === 1) {
          limit = 500;
        }
        const tOut = setTimeout(() => {
          clearTimeout(tOut);
          if (tFailsFormat.filter(Boolean).length > 0) {
            onFormatNotAllowed();
          }
          if (tFailsSize.filter(Boolean).length > 0) {
            onMaxSizeAllowedOver();
          }
        }, limit);
      } else {
        const tIn = setTimeout(() => {
          clearTimeout(tIn);
          onFilesValidated(true);
        }, 500);
      }
    }

    if (cleanAll) {
      handleRemoveFiles();
      onAfterClean();
      setFilesValidationDone(false);
    }
  });

  return (
    <>
      <DragAndDropArea>
        {filesToSend.length ? (
          <>
            <Interactive
              bkgColorEnabled="none"
              bkgColorHover="#E2DFFD"
              bkgColorFocus="#C6C0FC"
              bkgColorPressed="#C6C0FC"
              onClick={onRequestRemoveFiles}
              className="trash"
              customized
              width="40px"
              height="40px"
              borderRadius="4px"
              alignContent="center"
              justifyContent="center"
              alignItems="center"
            >
              <Icon customized maxWidth="18.18px" height="20px">
                <img alt="remover" src={trashIcon} />
              </Icon>
            </Interactive>
          </>
        ) : (
          <></>
        )}
        <Block
          customized
          backgroundColor="#fff"
          border="1px dashed #B494FF"
          width={isMobile ? '100%' : '552px'}
          onDrop={(event: any) =>
            withDrapAndDrop && !dragAndDropAreaPaused
              ? handleDrop(event)
              : () => false
          }
          onDragOver={(event: any) => handleDragOver(event)}
          onDragEnter={(event: any) => handleDragEnter(event)}
          minHeight="248px"
          alignContent="center"
          justifyContent="center"
          alignItems="center"
        >
          <Block
            customized
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            width="100%"
          >
            <Icon
              customized
              maxWidth="56px"
              height="56px"
              margin="0px 0px 24px"
            >
              <img src={PlaceHolderImage} alt="placeholder" />
            </Icon>
          </Block>
          <Block
            alignContent="center"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            maxWidth="244px"
          >
            {filesToSend.length ? (
              <Block customized maxWidth="244px" margin="0px 0px 32px">
                {filesToSend.map((file: any) => (
                  <>
                    <UploadFile
                      key={IDHelpers.generateID()}
                      labelName={
                        file?.name?.length > 14
                          ? `${TextHelpers.truncateString(
                              file?.name,
                              14
                            )}...${getExt(file?.name).toLowerCase()}`
                          : file?.name
                      }
                      labelSize={`${bytesToMegaBytes(file?.size, 0, true)} MB`}
                      timeToWait={bytesToMegaBytes(file?.size, 0, true)}
                      isValid={validateFile(file)}
                    />
                  </>
                ))}
              </Block>
            ) : (
              <Block
                customized
                alignContent="center"
                justifyContent="center"
                alignItems="center"
              >
                <Text
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="400"
                  textAlign="center"
                >
                  Solo puedes subir en formato {getFileFormat(mimeTypeFormats)}.
                </Text>
                <Text
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="700"
                  textAlign="center"
                >
                  (Tamaño máximo de archivo:{` `}
                  {maxFileSize} MB)
                </Text>
                <Interactive
                  someRef={ButtonRef}
                  borderRadius="4px"
                  bkgColorEnabled="none"
                  bkgColorHover="#E2DFFD"
                  bkgColorFocus="#C6C0FC"
                  bkgColorPressed="#C6C0FC"
                  customized
                  alignContent="center"
                  alignItems="center"
                  justifyContent="center"
                  width="141px"
                  height="40px"
                  margin="34px 0px 0px"
                  onClick={() => handleClick()}
                  as="button"
                >
                  <Block
                    customized
                    alignContent="center"
                    alignItems="center"
                    flexDirection="row"
                    justifyContent="center"
                  >
                    <Icon
                      customized
                      maxWidth="18px"
                      height="19px"
                      margin="0px 6px 0px 0px"
                    >
                      <img src={UploaderIcon} alt="placeholder" />
                    </Icon>
                    <Text
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="700"
                      textAlign="center"
                      color="#5B36F2"
                    >
                      Subir archivo
                    </Text>
                  </Block>
                </Interactive>
              </Block>
            )}
            <input
              accept={allowedFormats}
              onChange={() => handleFileSelected()}
              ref={inputOpenFileRef}
              type="file"
              multiple={multiple}
              style={{ display: 'none' }}
            />
          </Block>
        </Block>
      </DragAndDropArea>
    </>
  );
};

export { DragAndDrop };
